<template>
  <!-- Mounted only while open, so the editor starts from the building's current photos every time -->
  <Modal ref="modalRef" position="end" width="46.25rem">
    <template #header>Building photos</template>
    <template #body>
      <PropertyImagesEdit title="Photos" :store="imagesStore" :can-sort="false" />
    </template>
    <template #footer>
      <Button variant="ghost" @click="modalRef?.close()">Cancel</Button>
      <Button :loading="imagesStore.isSaving" data-testid="save-photos" @click="save">Save</Button>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { ref } from 'vue';

import { Button, Modal } from '@tallo/design-system';
import { BuildingDto, PropertyImagesEdit, useBuildingImagesStore } from '@tallo/investor/property';

/**
 * The unit's photo editor over the building's gallery. Uploads and removals land at once; the order
 * is saved on Save, and the first photo becomes the cover.
 */
const props = defineProps<{ building: BuildingDto }>();

const modalRef = ref<InstanceType<typeof Modal>>();
const imagesStore = useBuildingImagesStore();

function open() {
  imagesStore.open(props.building);
  modalRef.value?.show();
}

async function save() {
  await imagesStore.updateImagesOrder();
  modalRef.value?.close();
}

defineExpose({ open });
</script>
